import { render } from "./gpu.vue?vue&type=template&id=7f94a27e&scoped=true"
import script from "./gpu.vue?vue&type=script&lang=js"
export * from "./gpu.vue?vue&type=script&lang=js"

import "./gpu.vue?vue&type=style&index=0&id=7f94a27e&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f94a27e"]])

export default __exports__